<template>
  <table style="width: 100%">
    <tbody>
      <tr>
        <td class="celda-cabecera" style="width: 10%">ORDEN</td>
        <td style="width: 1%"></td>
        <td class="celda-cabecera" style="width: 69%">CONCEPTO</td>
        <td class="celda-cabecera" style="width: 20%">MONTO</td>
      </tr>

      <tr v-for="detalle in detalles" :key="detalle.id">
        <td class="celda-cuerpo celda-cuerpo--numerico" style="width: 10%">
          {{ detalle.orden }}
        </td>

        <td style="width: 1%"></td>

        <td class="celda-cuerpo" style="width: 69%">
          {{ detalle.conceptoUniversidad.concepto.nombre }}
        </td>

        <td class="celda-cuerpo celda-cuerpo--numerico" style="width: 20%">
          {{ formatearValorAMoneda(detalle.monto) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'TablaDetallesListaCostosConvenio',
  props: {
    detalles: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
  },
};
</script>

<style scoped>
.celda-cabecera {
  font-size: 0.725rem;
  font-weight: bolder;
  padding: 0.125rem 0.5rem;
  border-left: 1px solid #e0e0e0;
}

.celda-cuerpo {
  border-top: 1px solid #e0e0e0;
  padding: 0.125rem 0.5rem;
  border-left: 1px solid #e0e0e0;
}

.celda-cuerpo--numerico {
  text-align: right;
}
</style>
